const kebabCase = require("lodash/kebabCase")

const doenerCase = (str) => {
  str = str.toLowerCase()
  str = str.replace(/ä/g, "ae")
  str = str.replace(/ü/g, "ue")
  str = str.replace(/ö/g, "oe")
  str = kebabCase(str)

  return str
}

module.exports = doenerCase
